
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import { CreateUser } from '@/settings/application/uses_cases/user/create/CreateUser'; //UPDATE_USER
import { UpdateUser } from '@/settings/application/uses_cases/user/update/UpdateUser'; //
import { CreateRole } from '@/settings/application/uses_cases/role/create/CreateRole';
import { UpdateRole } from '@/settings/application/uses_cases/role/update/UpdateRole';
import { RoleFindById } from '@/settings/application/uses_cases/role/search/RoleFindById';
import { RoleFindMenuPlaneByRoleId } from '@/settings/application/uses_cases/role/search/RoleFindMenuPlaneByRoleId';
import { RoleFindAll } from '@/settings/application/uses_cases/role/search/RoleFindAll';
import { ValidationObserver } from 'vee-validate/dist/types/components';
import { RoleFindByCompanyId } from '@/settings/application/uses_cases/role/search/RoleFindByCompanyId';
import { Role } from '@/settings/domain/role/Role';
import { User } from '@/settings/domain/user/User';
import Draggable from 'vuedraggable';
import AppRole from '@/settings/infrastructure/ui/components/role/Role.vue';
import CreateNewRole from '@/settings/infrastructure/ui/components/role/CreateNewRol.vue';
import { FileFindAll } from '@/settings/application/uses_cases/file/search/FileFindAll';
import { CreateFile } from '@/settings/application/uses_cases/file/create/CreateFile';
import PictureInput from 'vue-picture-input';

@Component({
  name: 'UserManagement',
  components: {
    Draggable,
    AppRole,
    PictureInput,
    CreateNewRole
  }
})
export default class UserManagement extends Vue {
  @Inject(TYPES.FINDBYMENU_ROLE)
  readonly roleFindById!: RoleFindById;
  @Inject(TYPES.FINDMENUPLANEBYROLEID_ROLE)
  readonly roleFindMenuPlaneByRoleId!: RoleFindMenuPlaneByRoleId;
  @Inject(TYPES.CREATE_ROLE)
  readonly createRole!: CreateRole;
  @Inject(TYPES.UPDATE_ROLE)
  readonly updateRole!: UpdateRole;
  @Inject(TYPES.FINDALL_ROLE)
  readonly roleFindAll!: RoleFindAll;
  @Inject(TYPES.FIND_ROLE_BY_COMPANY_ID)
  readonly findRolesByCompanyId!: RoleFindByCompanyId;
  @Inject(TYPES.CREATE_USER)
  readonly createUser!: CreateUser;
  @Inject(TYPES.UPDATE_USER)
  readonly updateUser!: UpdateUser;
  @Inject(TYPES.FINDALL_FILE)
  readonly fileFindAll!: FileFindAll;
  @Inject(TYPES.CREATE_FILE)
  readonly createFile!: CreateFile;

  isLoading = false;
  fullPage = true;
  isNew = true;
  roles: Role[] = [];
  payloadUser = new User();
  payloadRole: Role = new Role();
  urlBase64Logo = '';
  image = '';
  urlLogo = '';
  urlImage: any;

  //Refs
  $refs!: {
    formUser: InstanceType<typeof ValidationObserver>;
    pictureInput: HTMLFormElement;
    mdCreateRole: HTMLFormElement;
  };

  mounted() {
    this.findAllRolesByCompanyId();
  }

  onChanged() {
    if (this.$refs.pictureInput.file) {
      this.image = this.$refs.pictureInput.file;
    }
  }

  onRemoved() {
    this.image = '';
  }

  findImage() {
    this.fileFindAll
      .execute(this.urlImage.replace('file/getImageAsByteArray?name=', this.urlLogo))
      .then((resp: any) => {
        this.urlBase64Logo = resp['base64'];
      })
      .catch((error: any) => {
        throw new Error(error);
      });
  }

  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }

  async factory() {
    if (this.image) {
      const payloadImg: any = {
        contentType: this.$refs.pictureInput.file.type,
        name: '',
        size: this.$refs.pictureInput.file.size,
        base64: this.$refs.pictureInput.image
      };
      const extension = this.$refs.pictureInput.file.name.split('.').pop();
      payloadImg.name = this.payloadUser.customerId.trim() + '.' + extension;
      this.urlImage = payloadImg.name;
      this.payloadUser.logo = this.urlImage;
      await this.createFile.execute(payloadImg);
    } else if (this.$refs.pictureInput.image === '') {
      this.urlImage = '';
    }

    if (this.isNew) {
      this.saveUser();
    } else {
      this.updateExisitngUser();
    }
    this.findAllRolesByCompanyId();
  }

  //Methods
  async findAllRolesByCompanyId() {
    this.isLoading = true;
    const companyId = '' + localStorage.getItem('businessId');
    await this.findRolesByCompanyId
      .execute(companyId)
      .then((response: any) => {
        this.isLoading = false;
        this.roles = response;
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.roles = [];
        throw new Error(`${error}`);
      });
    this.cleanUserForm();
  }

  selectUser(user: User, role: Role) {
    this.$refs.formUser.reset();
    this.isNew = false;
    const roleArray: Role[] = [];
    const newRole = new Role();
    newRole.id = role.id;
    newRole.name = role.name;
    roleArray.push(newRole);
    this.payloadUser = user;
    this.payloadUser.password = '';
    this.payloadUser.confirmPassword = '';
    this.payloadUser.roles = roleArray;
    this.urlLogo = user.logo;
    this.urlImage = user.logo;
    this.findImage();
  }

  selectedRole(role: Role) {
    this.isNew = true;
    this.payloadRole = role;
    this.cleanUserForm();
  }

  async updateExisitngUser() {
    this.isLoading = true;
    await this.updateUser
      .execute(this.payloadUser)
      .then(() => {
        this.isLoading = false;
        this.cleanUserForm();
        this.findAllRolesByCompanyId();
      })
      .catch(error => {
        this.isLoading = false;
        throw new Error(`${error}`);
      });
  }

  async saveUser() {
    this.isLoading = true;
    const companyId = '' + localStorage.getItem('businessId');
    const profile = '' + localStorage.getItem('profile');
    this.payloadUser.businessId = companyId;
    this.payloadUser.configProfile = profile;
    this.payloadUser.logo = this.urlImage;
    this.payloadUser.roles = [];
    this.payloadUser.roles.push(this.payloadRole);
    await this.createUser
      .execute(this.payloadUser)
      .then(() => {
        this.isLoading = false;
        this.cleanUserForm();
        this.findAllRolesByCompanyId();
      })
      .catch(error => {
        this.isLoading = false;
        throw new Error(`${error}`);
      });
  }

  get hasRoleAsigned() {
    if (this.payloadRole.name !== '') return false;

    return true;
  }

  cleanUserForm() {
    this.isNew = true;
    this.$refs.formUser.reset();
    this.payloadUser = new User();
    this.urlBase64Logo = '';
    this.image = '';
  }

  closeModal(isSuccessful: boolean) {
    if (isSuccessful) {
      this.$refs.mdCreateRole.hide('mdCreateRole');
      this.findAllRolesByCompanyId();
    }
  }
}
